"use client";

import { useId, useState } from "react";
import Comparison from "@/components/preview/comparison";
import { Kbd } from "@/components/ui/kbd";
import DemoInput from "../demo-input";

const TEXT_KEYS = ["q", "w", "e", "r", "t", "y", "u", "i"];
const EMAIL_KEYS = ["q", "w", "e", "r", "t", "y", "@", "."];

function KeyboardStrip({ keys }: { keys: string[] }) {
  return (
    <div
      aria-hidden="true"
      className="flex select-none items-center justify-center gap-1"
    >
      {keys.map((key) => (
        <Kbd
          className="h-7 min-w-7 px-1.5 pb-0.5 font-berkeley-mono text-sm"
          key={key}
          uppercase={false}
          variant="raised"
        >
          {key}
        </Kbd>
      ))}
    </div>
  );
}

export default function AccessibilityInputLabelsDemo() {
  const emailId = useId();
  const [badValue, setBadValue] = useState("");
  const [goodValue, setGoodValue] = useState("");

  return (
    <Comparison
      bad={
        <>
          <div className="flex w-full max-w-56 flex-col gap-2">
            <span
              aria-hidden="true"
              className="invisible select-none text-gray-1000 text-sm"
            >
              Email
            </span>
            <DemoInput
              aria-label="Email, the placeholder-only example"
              autoComplete="off"
              onChange={(event) => setBadValue(event.target.value)}
              placeholder="Email"
              size="sm"
              type="text"
              value={badValue}
            />
          </div>
          <KeyboardStrip keys={TEXT_KEYS} />
          <p className="sr-only">
            This field only has a placeholder, which disappears as soon as you
            type and its text type brings up the generic keyboard on touch
            devices.
          </p>
        </>
      }
      good={
        <>
          <div className="flex w-full max-w-56 flex-col gap-2">
            <label
              className="select-none text-gray-1000 text-sm"
              htmlFor={emailId}
            >
              Email
            </label>
            <DemoInput
              autoComplete="email"
              id={emailId}
              inputMode="email"
              onChange={(event) => setGoodValue(event.target.value)}
              placeholder="you@example.com"
              size="sm"
              type="email"
              value={goodValue}
            />
          </div>
          <KeyboardStrip keys={EMAIL_KEYS} />
        </>
      }
      panelClassName="h-48 px-6"
      stackBelow="md"
    />
  );
}
